<section class="vh-100" style="background-color: #508bfc">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-2-strong" style="border-radius: 1rem">
          <div class="card-body p-5 text-center">
            <form>
              <img src="/assets/img/logo_black.png" class="mb-4" />
              <div class="form-floating mb-4">
                <input
                  type="text"
                  autocomplete="username"
                  id="username"
                  class="form-control"
                  [(ngModel)]="auth.username"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label for="username">Username</label>
              </div>
              <div class="form-floating mb-4">
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  autocomplete="current-password"
                  [(ngModel)]="auth.password"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label for="password">Password</label>
              </div>
              <div *ngIf="badCredentials" class="form-floating mb-4">
                <p class="text-danger">Las credenciales no son correctas.</p>
              </div>

              <button
                class="btn btn-primary"
                type="submit"
                (click)="onSubmit()"
              >
                LOGIN
              </button>
              <div *ngIf="auth.error">
                <hr class="my-4" />
                <div class="alert alert-danger mt-3" role="alert">
                  {{ auth.error }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
